"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.NeighborhoodSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<rect x="4" y="16" width="13" height="7" rx="1"/><rect x="23" y="11" width="2" height="19" rx="1"/><path d="M29.38 10.91a7 7 0 00-1.86-2.31A5 5 0 0028 6.5 4.27 4.27 0 0024 2a3.92 3.92 0 00-3.32 2 5 5 0 00-.41 4.12 4.4 4.4 0 00.21.5A6.41 6.41 0 0018 13.7a6.22 6.22 0 005 6.21V12a1 1 0 012 0v7.91a6.22 6.22 0 005-6.21 6.12 6.12 0 00-.62-2.79zM18 25H3a1 1 0 000 2h1v2a1 1 0 002 0v-2h9v2a1 1 0 002 0v-2h1a1 1 0 000-2z"/>';
var NeighborhoodSVG = function NeighborhoodSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.NeighborhoodSVG = NeighborhoodSVG;
NeighborhoodSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(NeighborhoodSVG);
exports.default = _default;